import React, { FC } from 'react';
import { FieldWrapper } from 'components/teaching-inputs/common';
import { Field } from 'redux-form';
import {
  RequestTutoringFields,
  useCurrentFormValues,
} from 'src/pages-all/details/tutor/components/RequestTutoringModal/request-tutoring-form.logic';
import { FormTextInput } from 'components/form-inputs/form-text-input/form-text-input';
import { RequestStepContainer, RequestTutoringButton } from '../components';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { useCurrentOffer } from 'logic/hooks/useCurrentOffer';
import { Text } from 'components/text/Text';
import styled from 'styled-components';

const HoursInputWrapper = styled(FieldWrapper)`
  width: 50%;
  min-width: 100px;
`;

export const HoursStep: FC = () => {
  const { offer } = useCurrentOffer();
  const { tutoringSessionsPerMonth } = useCurrentFormValues();
  const firstName = offer?.user?.firstName;
  const buttonDisabled =
    !tutoringSessionsPerMonth || tutoringSessionsPerMonth > 40 || tutoringSessionsPerMonth < 1;

  return (
    <RequestStepContainer
      title={translate(translationKeys.requestTutoringFlow.privateRequest, { firstName })}
    >
      <Text size={16}>{translate(translationKeys.requestTutoringFlow.howManyHours)}</Text>
      <HoursInputWrapper>
        <Field
          name={RequestTutoringFields.Hours}
          component={FormTextInput}
          type={'number'}
          normalize={(value: string) => (Number(value) > 0 ? Number(value) : value)}
          required
          onlyNumbers
          placeholder={translate(translationKeys.requestTutoringFlow.howManyHoursPlaceholder)}
        />
      </HoursInputWrapper>
      <Text size={14} style={{ fontStyle: 'italic' }}>
        {translate(translationKeys.requestTutoringFlow.howManyHoursDisclaimer)}
      </Text>
      <RequestTutoringButton disabled={buttonDisabled} />
    </RequestStepContainer>
  );
};
